<div class="body">
  <div class="sidebar" [class.isSmall]="!showSidebar">
    <app-main-sidebar></app-main-sidebar>
  </div>

  <div class="content" cdkScrollable>
    <router-outlet></router-outlet>
  </div>
</div>